import React from 'react'
import { Outlet } from 'react-router-dom'

const DepensesHomePage = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default DepensesHomePage